<template>
  <nav style="z-index: 100">
    <v-toolbar :flat="currentUser === null" elevation="0">
      <v-app-bar-nav-icon
        @click="drawer = !drawer"
        class="text-grey"
        v-if="currentUser"
      ></v-app-bar-nav-icon>
      <v-toolbar-title class="text-uppercase color-text-second d-flex justify-end mr-6">
        <div class="d-flex align-center">
          <v-img width="30" :src="require('@/assets/logo.png')"></v-img>
          <div class="ml-2 font-weight-bold">DES<span class="font-weight-thin">GREEN</span></div>
        </div>
      </v-toolbar-title>
    </v-toolbar>

    <v-navigation-drawer
      app
      class="nav-color-second"
      v-model="drawer"
      v-if="showNavbar"
    >

      <v-list nav>
        <v-list-item v-if="currentUser" class="mt-4" value="admin-profile" @click="toChangeProfile">
          <div class="d-flex flex-row">
            <v-avatar>
              <v-img
                  :lazy-src="lookupImageUrlLazy(currentUser)"
                  :src="lookupImageUrl(currentUser)"
              ></v-img>
            </v-avatar>
            <div class="ml-2 d-flex flex-column">
              <div class="text-subtitle-2 text-white font-weight-bold">{{ currentUser.username }} </div>
              <div class="text-caption text-white font-weight-light">{{ currentUser.email }} </div>
            </div>
          </div>
        </v-list-item>
        <v-text-field v-model="search" density="compact" variant="plain" hide-details class="mx-2 search-field" placeholder="search" ></v-text-field>
        <v-divider class="mt-2 text-white"></v-divider>

        <v-list-item class="text-white text-body-2 font-weight-medium" to="/dashboard-utama" link prepend-icon="mdi-rocket" value="dashboard">Dashboard</v-list-item>
        <v-list-group
            :value="nav_drawer.title"
            v-for="nav_drawer in filteredNavDrawers.filter((x) => x.visible)"
            :key="nav_drawer.title">
              <template v-slot:activator="{ props }">
                <v-list-item
                    class="text-body-2 text-white font-weight-medium"
                    :prepend-icon="nav_drawer.icon"
                    v-bind="props"
                >{{nav_drawer.title}}</v-list-item>
              </template>
              <v-list-item
                v-for="submenu in nav_drawer.items.filter((x) => x.visible)"
                :key="submenu.title"
                :append-icon="submenu.icon"
                link
                :to="submenu.route"
                class="text-white text-caption"
              >
                {{submenu.title}}
                <v-divider v-if="submenu.useDivider" color="white" class="mt-3"></v-divider>
              </v-list-item>
        </v-list-group>

        <v-divider class="text-white"></v-divider>
        <v-list-group
            :value="nav_drawer.title"
            v-for="nav_drawer in nav_drawers_analisis.filter((x) => x.visible)"
            :key="nav_drawer.title">
          <template v-slot:activator="{ props }">
            <v-list-item
                :prepend-icon="nav_drawer.icon"
                v-bind="props"
                class="text-body-2 text-white font-weight-medium"
            >{{nav_drawer.title}}</v-list-item>
          </template>
          <v-list-item
              v-for="submenu in nav_drawer.items.filter((x) => x.visible)"
              :key="submenu.title"
              link
              :to="submenu.route"
              class="text-white text-caption"
          >{{submenu.title}}</v-list-item>
        </v-list-group>
        <v-divider class="text-white"></v-divider>

        <v-list-group
            :value="nav_drawer.title"
            v-for="nav_drawer in nav_drawers_setup.filter((x) => x.visible)"
            :key="nav_drawer.title">
          <template v-slot:activator="{ props }">
            <v-list-item
                :prepend-icon="nav_drawer.icon"
                v-bind="props"
                class="text-body-2 text-white font-weight-medium"
            >{{nav_drawer.title}}</v-list-item>
          </template>
          <v-list-item
              v-for="submenu in nav_drawer.items.filter((x) => x.visible)"
              :key="submenu.title"
              link
              :to="submenu.route"
              class="text-white text-caption"
          >{{submenu.title}}</v-list-item>
        </v-list-group>

        <v-divider class="text-white"></v-divider>
        <v-list-item class="text-white text-body-2 font-weight-medium" prepend-icon="mdi-power" value="keluar" @click="logOut">Keluar</v-list-item>
      </v-list>

      <div class="my-16">
      </div>

    </v-navigation-drawer>
  </nav>
</template>

<script>
import ERole, {ERoleValues} from "../models/enum/e-role";
import FileService from "../services/apiservices/file-service";
import TestService from "../services/test-service";
import EOrganizationLevel from "@/models/enum/e-organization-level";
import FDivisionService from "@/services/apiservices/f-division-service";

export default {
  components: {},
  data() {
    return {
      search: '',
      top_menus: [
        {
          icon: "mdi-pencil",
          title: "Ubah Profile",
          route: "/change-profile",
          action: "",
          visible: true,
          iconColor: "orange",
        },
        {
          icon: "mdi-power",
          title: "Keluar",
          route: "#",
          action: "logOut",
          visible: true,
          iconColor: "red",
        },
      ],
      drawer: true,
      currentUserDivision: {id:0, description:''},
    };
  },
  watch: {},
  computed: {
    currentUser() {
      // console.log( `Isinya ${this.$store.state.auth.user}` )
      return this.$store.state.auth.user;
    },
    showNavbar() {
      if (this.currentUser && this.currentUser.roles) {
        return this.currentUser.roles;
      }
      return false;
    },
    isSellinSastro(){
      const names = ['SASTRO', 'SELLIN'];
      return this.currentUserDivision?(names.some(x => this.currentUserDivision.description.includes(x)) ): false
    },


    filteredNavDrawers() {
      // Lowercase keyword for case-insensitive search
      const keyword = (this.search || '').toLowerCase();
      // Helper: check if string contains keyword
      const match = (str) => (str || '').toLowerCase().includes(keyword);
      // Filter nav_drawers by visible, and search
      return this.nav_drawers
        .filter(nav_drawer => nav_drawer.visible)
        .map(nav_drawer => {
          // Only submenus that are visible
          const visibleSubmenus = (nav_drawer.items || []).filter(item => item.visible);
          // If no search, return as is
          if (!keyword) {
            return {
              ...nav_drawer,
              items: visibleSubmenus
            };
          }
          // Filter submenus by search keyword
          const filteredSubmenus = visibleSubmenus.filter(item => match(item.title));
          // If nav_drawer title matches, keep all visible submenus
          if (match(nav_drawer.title)) {
            return {
              ...nav_drawer,
              items: visibleSubmenus
            };
          }
          // If any submenu matches, keep only those
          if (filteredSubmenus.length > 0) {
            return {
              ...nav_drawer,
              items: filteredSubmenus
            };
          }
          // Otherwise, don't include this nav_drawer
          return null;
        })
        .filter(Boolean);
    },




    nav_drawers() {
      return [
        {
          title: 'Mitra',
          icon: 'mdi-account-group',
          active: false,
          visible: ERoleValues.some(x =>this.currentUser.roles.includes(x)),
          items: [
            {title: 'Customer', route: '/customer-old', icon: 'mdi-account-group', useDivider: false, visible:  [ ERole.ROLE_ADMIN, ERole.ROLE_ACC, ERole.ROLE_SALES_ADM, ERole.ROLE_MANAGER, ERole.ROLE_SALESMAN, ERole.ROLE_SPV].some(x =>this.currentUser.roles.includes(x)) },
            {title: 'Customer Type', route: '/cust-category', icon: 'mdi-file-tree',  useDivider: false, visible:  [ERole.ROLE_ADMIN, ERole.ROLE_ACC, ERole.ROLE_MANAGER, ERole.ROLE_SPV].some(x =>this.currentUser.roles.includes(x)) },
            {title: 'Wilayah', route: '/cust-region', icon: 'mdi-map',  useDivider: true, visible:  [ ERole.ROLE_ADMIN, ERole.ROLE_ACC, ERole.ROLE_SALES_ADM, ERole.ROLE_MANAGER, ERole.ROLE_SALESMAN, ERole.ROLE_SPV].some(x =>this.currentUser.roles.includes(x)) },
            {title: 'Supplier', route: '/supplier', icon: 'mdi-factory',  useDivider: false, visible:  [ ERole.ROLE_ADMIN, ERole.ROLE_ACC, ERole.ROLE_SALES_ADM, ERole.ROLE_MANAGER, ERole.ROLE_PURCHASE, ERole.ROLE_SPV].some(x =>this.currentUser.roles.includes(x)) },
          ],
        },
        // {
        //   title: 'Pembelian',
        //   icon: 'mdi-factory',
        //   active: false,
        //   visible:  [ERole.ROLE_ADMIN, ERole.ROLE_ADMIN1,  ERole.ROLE_ADMIN2, ERole.ROLE_USER, ERole.ROLE_PURCHASE, ERole.ROLE_PURCHASE_1, ERole.ROLE_PURCHASE_2].some(x =>this.currentUser.roles.includes(x)) ,
        //   items: [
        //     {title: 'PO', route: '/purchase-order', icon: 'mdi-email-outline', visible: [ERole.ROLE_ADMIN, ERole.ROLE_ADMIN1,  ERole.ROLE_ADMIN2, ERole.ROLE_USER, ERole.ROLE_PURCHASE, ERole.ROLE_PURCHASE_1, ERole.ROLE_PURCHASE_2].some(x =>this.currentUser.roles.includes(x)) },
        //     {title: 'Good Receipt', route: '/purchase-gr', icon: 'mdi-truck', visible: [ERole.ROLE_ADMIN, ERole.ROLE_ADMIN1,  ERole.ROLE_ADMIN2, ERole.ROLE_USER, ERole.ROLE_PURCHASE, ERole.ROLE_PURCHASE_1, ERole.ROLE_PURCHASE_2].some(x =>this.currentUser.roles.includes(x)) },
        //     {title: 'Invoice', route: '/purchase-invoice-type1', icon: 'mdi-credit-card-outline', visible: [ERole.ROLE_ADMIN, ERole.ROLE_ADMIN1,  ERole.ROLE_ADMIN2, ERole.ROLE_USER, ERole.ROLE_PURCHASE, ERole.ROLE_PURCHASE_1].some(x =>this.currentUser.roles.includes(x))  },
        //   ],
        // },
        {
          title: 'Penjualan',
          icon: 'mdi-cart',
          active: false,
          visible: ERoleValues.some(x =>this.currentUser.roles.includes(x)) ,
          items: [
            {title: 'Order & Invoice', route: '/sales-order-invoice', icon: 'mdi-cart', useDivider: false,  visible: [ERole.ROLE_ADMIN, ERole.ROLE_ACC, ERole.ROLE_SALES_ADM, ERole.ROLE_MANAGER, ERole.ROLE_SPV].some(x =>this.currentUser.roles.includes(x)) },
            {title: 'Warehouse & Delivery', route: '/sales-delivery', icon: 'mdi-truck-fast',  useDivider: false, visible: [ERole.ROLE_ADMIN, ERole.ROLE_ACC, ERole.ROLE_SALES_ADM, ERole.ROLE_MANAGER, ERole.ROLE_INVENTORY, ERole.ROLE_SPV].some(x =>this.currentUser.roles.includes(x)) },
            // {title: 'Return Management', route: '/sales-chart-return-management', icon: 'mdi-cart-off', visible: [ERole.ROLE_ADMIN, ERole.ROLE_ADMIN1,  ERole.ROLE_ADMIN2, ERole.ROLE_USER,  ERole.ROLE_INVENTORY,
            //     ERole.ROLE_INVENTORY_1, ERole.ROLE_INVENTORY_2].some(x =>this.currentUser.roles.includes(x)) },
            // {title: 'Sales Invoice', route: '/sales-chart-print-resi', icon: 'mdi-printer', visible: [ERole.ROLE_ADMIN, ERole.ROLE_ADMIN1, ERole.ROLE_ADMIN2, ERole.ROLE_USER, ERole.ROLE_SALES, ERole.ROLE_PIUTANG, ERole.ROLE_INVENTORY,
            //     ERole.ROLE_INVENTORY_1, ERole.ROLE_INVENTORY_2].some(x =>this.currentUser.roles.includes(x)) },
            {title: 'Export Sales Detil', route: '/export-sales-chart-detil', icon: 'mdi-microsoft-excel',  useDivider: true, visible:  [ERole.ROLE_ADMIN, ERole.ROLE_ACC, ERole.ROLE_SALES_ADM, ERole.ROLE_MANAGER, ERole.ROLE_SPV, ERole.ROLE_SALESMAN].some(x =>this.currentUser.roles.includes(x)) },
            // {title: 'Sales Summary', route: '/sales-chart-summary-product', icon: 'mdi-printer', visible: [ERole.ROLE_ADMIN, ERole.ROLE_ADMIN1, ERole.ROLE_ADMIN2, ERole.ROLE_USER, ERole.ROLE_SALES, ERole.ROLE_PIUTANG, ERole.ROLE_INVENTORY,
            //     ERole.ROLE_INVENTORY_1, ERole.ROLE_INVENTORY_2].some(x =>this.currentUser.roles.includes(x)) },
            {title: 'Salesman', route: '/pegawai', icon: 'mdi-account',  useDivider: false, visible: [ERole.ROLE_ADMIN, ERole.ROLE_ACC, ERole.ROLE_SALES_ADM, ERole.ROLE_MANAGER, ERole.ROLE_SPV].some(x =>this.currentUser.roles.includes(x)) },
            {title: 'Call Plan', route: '/sales-call-plan', icon: 'mdi-calendar-text',  useDivider: false, visible: [ERole.ROLE_ADMIN, ERole.ROLE_ACC, ERole.ROLE_SALES_ADM, ERole.ROLE_MANAGER, ERole.ROLE_SPV].some(x =>this.currentUser.roles.includes(x)) },
            {title: 'Call Activity', route: '/sales-call-activity', icon: 'mdi-cellphone-iphone',  useDivider: false, visible: [ERole.ROLE_ADMIN, ERole.ROLE_ACC, ERole.ROLE_SALES_ADM, ERole.ROLE_MANAGER, ERole.ROLE_SPV].some(x =>this.currentUser.roles.includes(x)) },
            {title: 'NOO', route: '/sales-call-new-outlet-order', icon: 'mdi-account-multiple-plus',  useDivider: false, visible: [ERole.ROLE_ADMIN, ERole.ROLE_ACC, ERole.ROLE_SALES_ADM, ERole.ROLE_MANAGER, ERole.ROLE_SPV].some(x =>this.currentUser.roles.includes(x)) },

          ],
        },

        {
          title: 'Inventory',
          icon: 'mdi-warehouse',
          active: false,
          visible: ERoleValues.some(x =>this.currentUser.roles.includes(x)) ,
          items: [
            // {title: 'Penyesuaian', route: '/penyesuaian-stock', icon: 'mdi-scale-balance', visible: [ERole.ROLE_ADMIN, ERole.ROLE_ADMIN1,  ERole.ROLE_ADMIN2, ERole.ROLE_USER, ERole.ROLE_INVENTORY, ERole.ROLE_INVENTORY_1].some(x =>this.currentUser.roles.includes(x)) },
            // {title: 'Mutasi/Transfer', route: '/mutasi-transfer-stock', icon: 'mdi-share', visible: [ERole.ROLE_ADMIN, ERole.ROLE_ADMIN1,  ERole.ROLE_ADMIN2, ERole.ROLE_USER, ERole.ROLE_INVENTORY, ERole.ROLE_INVENTORY_1].some(x =>this.currentUser.roles.includes(x)) },
            {title: 'Stock Barang', route: '/saldo-stock', icon: 'mdi-format-list-checks',  useDivider: false, visible: [ERole.ROLE_ADMIN, ERole.ROLE_ACC, ERole.ROLE_SALES_ADM, ERole.ROLE_MANAGER, ERole.ROLE_INVENTORY, ERole.ROLE_PURCHASE, ERole.ROLE_SALESMAN, ERole.ROLE_SPV].some(x =>this.currentUser.roles.includes(x)) },
            {title: 'Prediksi Stock (AI)', route: '/warning-stock', icon: 'mdi-exclamation',  useDivider: false, visible: [ERole.ROLE_ADMIN, ERole.ROLE_ACC, ERole.ROLE_SALES_ADM, ERole.ROLE_MANAGER, ERole.ROLE_INVENTORY, ERole.ROLE_PURCHASE, ERole.ROLE_SPV].some(x =>this.currentUser.roles.includes(x)) },
            {title: 'Summary LP3', route: '/summary-lp3', icon: 'mdi-chart-timeline',  useDivider: true, visible: [ERole.ROLE_ADMIN, ERole.ROLE_ACC, ERole.ROLE_SALES_ADM, ERole.ROLE_MANAGER, ERole.ROLE_INVENTORY, ERole.ROLE_PURCHASE, ERole.ROLE_SALESMAN, ERole.ROLE_SPV].some(x =>this.currentUser.roles.includes(x)) },
            // {title: 'Umur Stock', route: '/umur-stock', icon: 'mdi-timer-sand',  useDivider: false, visible: [ERole.ROLE_ADMIN, ERole.ROLE_ACC, ERole.ROLE_SALES_ADM, ERole.ROLE_MANAGER, ERole.ROLE_INVENTORY, ERole.ROLE_PURCHASE, ERole.ROLE_SPV].some(x =>this.currentUser.roles.includes(x)) },
            {title: 'Warehouse', route: '/warehouse', icon: 'mdi-warehouse',  useDivider: false, visible:  [ERole.ROLE_ADMIN, ERole.ROLE_ACC, ERole.ROLE_SALES_ADM, ERole.ROLE_MANAGER, ERole.ROLE_SPV].some(x =>this.currentUser.roles.includes(x)) },
          ],
        },
        {
          title: 'Cloud Mobile',
          icon: 'mdi-cloud-sync',
          active: false,
          visible: [ERole.ROLE_ADMIN, ERole.ROLE_ACC, ERole.ROLE_SALES_ADM, ERole.ROLE_MANAGER].some(x =>this.currentUser.roles.includes(x)),
          items: [
            {title: 'Cloud Order', route: '/mobile-order-entry', icon: 'mdi-tablet-android',  useDivider: false, visible:  [ERole.ROLE_ADMIN, ERole.ROLE_ACC, ERole.ROLE_SALES_ADM, ERole.ROLE_MANAGER].some(x =>this.currentUser.roles.includes(x)) },
            {title: 'Export Order', route: '/export-cloud-sales-chart-order', icon: 'mdi-microsoft-excel',  useDivider: true, visible:  [ERole.ROLE_ADMIN, ERole.ROLE_ACC, ERole.ROLE_SALES_ADM, ERole.ROLE_MANAGER, ERole.ROLE_SPV].some(x =>this.currentUser.roles.includes(x)) },
            //KHUSUS UNTUK SELLIN SASTRO
            {title: 'Sellin: Log Sync', route: '/log-exim', icon: '',  useDivider: false, visible: this.isSellinSastro && [ERole.ROLE_ADMIN].some(x =>this.currentUser.roles.includes(x)) },
            {title: 'Sellin: Log Extend Check', route: '/sastro-log-ext-check', icon: '',  useDivider: false, visible: this.isSellinSastro && [ERole.ROLE_ADMIN].some(x =>this.currentUser.roles.includes(x)) },
          ],
        },
        {
          title: 'Tax Management',
          icon: 'mdi-feather',
          active: false,
          visible:  [ERole.ROLE_ADMIN, ERole.ROLE_ACC, ERole.ROLE_FINANCE].some(x =>this.currentUser.roles.includes(x)),
          items: [
            {title: 'Tax Keluaran', route: '/tax-keluaran', icon: 'mdi-feather',  useDivider: false, visible:  [ERole.ROLE_ADMIN, ERole.ROLE_ACC, ERole.ROLE_FINANCE].some(x =>this.currentUser.roles.includes(x)) },
            {title: 'Master Tax', route: '/admin-master-tax', icon: 'mdi-feather',  useDivider: false, visible: [ERole.ROLE_ADMIN, ERole.ROLE_ACC, ERole.ROLE_SALES_ADM, ERole.ROLE_MANAGER].some(x =>this.currentUser.roles.includes(x)) },
          ],
        },

        {
          title: 'Produk',
          icon: 'mdi-barcode',
          active: false,
          visible:  [ERole.ROLE_ADMIN, ERole.ROLE_ACC, ERole.ROLE_SALES_ADM, ERole.ROLE_MANAGER, ERole.ROLE_SPV].some(x =>this.currentUser.roles.includes(x)),
          items: [
            {title: 'Produk', route: '/product', icon: 'mdi-barcode',  useDivider: false, visible:  [ERole.ROLE_ADMIN, ERole.ROLE_ACC, ERole.ROLE_SALES_ADM, ERole.ROLE_MANAGER, ERole.ROLE_SPV].some(x =>this.currentUser.roles.includes(x)) },
            {title: 'Group Produk', route: '/product-category', icon: 'mdi-group',  useDivider: false, visible: [ERole.ROLE_ADMIN, ERole.ROLE_ACC, ERole.ROLE_SALES_ADM, ERole.ROLE_MANAGER].some(x =>this.currentUser.roles.includes(x)) },
            {title: 'Brand', route: '/product-sales-chart-brand', icon: 'mdi-tag-text',  useDivider: true, visible: [ERole.ROLE_ADMIN, ERole.ROLE_ACC, ERole.ROLE_SALES_ADM, ERole.ROLE_MANAGER].some(x =>this.currentUser.roles.includes(x)) },
            {title: 'Promotion Rules', route: '/admin-promotion-rules', icon: 'mdi-gift',  useDivider: false, visible: [ERole.ROLE_ADMIN, ERole.ROLE_ACC, ERole.ROLE_SALES_ADM, ERole.ROLE_MANAGER].some(x =>this.currentUser.roles.includes(x)) },
          ],
        },
        // {
        //   title: 'Promotions',
        //   icon: 'mdi-gift',
        //   active: false,
        //   visible:  [ERole.ROLE_ADMIN, ERole.ROLE_ADMIN1,  ERole.ROLE_ADMIN2, ERole.ROLE_USER, ERole.ROLE_SALES].some(x =>this.currentUser.roles.includes(x)),
        //   items: [
        //     {title: 'Setting Promosi', route: '/setting-promosi', icon: 'mdi-gift', visible:  [ERole.ROLE_ADMIN, ERole.ROLE_ADMIN1,  ERole.ROLE_ADMIN2, ERole.ROLE_USER].some(x =>this.currentUser.roles.includes(x)) },
        //     {title: 'Report', route: '/promotions-report', icon: '', visible:  [ERole.ROLE_ADMIN, ERole.ROLE_ADMIN1,  ERole.ROLE_ADMIN2, ERole.ROLE_USER, ERole.ROLE_SALES].some(x =>this.currentUser.roles.includes(x)) },
        //   ],
        // },
        {
          title: 'Laporan',
          icon: 'mdi-chart-pie',
          active: false,
          visible: false,
          items: [
            {title: 'Sales to Items', route: '/reports', icon: '',  useDivider: false, visible:  true},
            {title: 'Analisis', route: '/reports-analisis', icon: 'mdi-chart-line',  useDivider: false, visible:  true},
            {title: 'Komisi', route: '/report-komisi', icon: '',  useDivider: false, visible:  true},
          ],
        },
        {
          title: 'Smart Toolkit',
          icon: 'mdi-tools',
          active: false,
          visible: ERoleValues.some(x => this.currentUser.roles.includes(x)),
          items: [
            {
              title: 'DES Lama',
              route: '/smart-toolkit/des-lama',
              icon: 'mdi-history',
              useDivider: false,
              visible: ERoleValues.some(x => this.currentUser.roles.includes(x))
            },
            {
              title: 'Sync to Main Server',
              route: '/smart-toolkit/sync-to-main-server',
              icon: 'mdi-cloud-sync',
              useDivider: false,
              visible: ERoleValues.some(x => this.currentUser.roles.includes(x))
            },
          ],
        },
      ];
    },

    nav_drawers_analisis() {
      // Lowercase keyword for case-insensitive search
      const keyword = (this.search || '').toLowerCase();
      const match = (str) => (str || '').toLowerCase().includes(keyword);
      // Base groups
      const groups = [
        {
          title: "Finance & Distribution Analisis",
          icon: "mdi-school",
          active: false,
          visible: [ERole.ROLE_ADMIN, ERole.ROLE_ACC, ERole.ROLE_SALES_ADM, ERole.ROLE_MANAGER].some((x) =>
              this.currentUser.roles.includes(x)
          ) && this.currentUser.organizationLevel !== EOrganizationLevel.DIV,
          items: [
            {
              title: "LDH: Cash Analisis (AI)",
              route: "/analisis-ldh-cash-analisis",
              icon: "",
              useDivider: false,
              visible:  [ERole.ROLE_ADMIN, ERole.ROLE_ACC, ERole.ROLE_SALES_ADM, ERole.ROLE_MANAGER].some(x =>this.currentUser.roles.includes(x))
            },
          ],
        },
        {
          title: "HR Analisis",
          icon: "mdi-flask-outline",
          active: false,
          visible: [ERole.ROLE_ADMIN, ERole.ROLE_ACC, ERole.ROLE_SALES_ADM, ERole.ROLE_MANAGER].some((x) =>
              this.currentUser.roles.includes(x)
          ) && this.currentUser.organizationLevel !== EOrganizationLevel.DIV,
          items: [
            {
              title: "-",
              route: "/#",
              icon: "",
              useDivider: false,
              visible:  [ERole.ROLE_ADMIN, ERole.ROLE_ACC, ERole.ROLE_SALES_ADM, ERole.ROLE_MANAGER].some(x =>this.currentUser.roles.includes(x))
            },
          ],
        },
      ];
      // Filter by visible group and visible submenus
      return groups
        .filter(group => group.visible)
        .map(group => {
          const visibleSubmenus = (group.items || []).filter(item => item.visible);
          if (!keyword) {
            return {
              ...group,
              items: visibleSubmenus
            };
          }
          const filteredSubmenus = visibleSubmenus.filter(item => match(item.title));
          if (match(group.title)) {
            return {
              ...group,
              items: visibleSubmenus
            };
          }
          if (filteredSubmenus.length > 0) {
            return {
              ...group,
              items: filteredSubmenus
            };
          }
          return null;
        })
        .filter(Boolean);
    },

    nav_drawers_setup() {
      // Lowercase keyword for case-insensitive search
      const keyword = (this.search || '').toLowerCase();
      const match = (str) => (str || '').toLowerCase().includes(keyword);
      // Base groups
    // && this.currentUser.organizationLevel !== EOrganizationLevel.DIV
      const groups = [
        {
          title: "Admin",
          icon: "mdi-cog-outline",
          active: false,
          visible: [ERole.ROLE_ADMIN, ERole.ROLE_SALES_ADM].some((x) =>
              this.currentUser.roles.includes(x)
          ) ,
          items: [
            {
              title: "Pengguna",
              route: "/admin-sistem",
              icon: "",
              useDivider: false,
              visible:  [ERole.ROLE_ADMIN, ERole.ROLE_SALES_ADM].some(x =>this.currentUser.roles.includes(x))
            },
            {
              title: "Struktur Organisasi Sistem",
              route: "/admin-struktur-organisasi-sistem",
              icon: "",
              useDivider: false,
              visible:  [ERole.ROLE_ADMIN].some(x =>this.currentUser.roles.includes(x))
            },
            {
              title: "Setting",
              route: "/admin-setting",
              icon: "",
              useDivider: false,
              visible:  [ERole.ROLE_ADMIN].some(x =>this.currentUser.roles.includes(x))
            },
            // {
            //   title: "Setting Aplikasi",
            //   route: "/admin-setting-one",
            //   icon: "",
            //   visible: [ERole.ROLE_ADMIN].some((x) =>
            //       this.currentUser.roles.includes(x)
            //   ) && this.currentUser.organizationLevel !== EOrganizationLevel.DIV,
            // },
          ],
        },
      ];
      // Filter by visible group and visible submenus
      return groups
        .filter(group => group.visible)
        .map(group => {
          const visibleSubmenus = (group.items || []).filter(item => item.visible);
          if (!keyword) {
            return {
              ...group,
              items: visibleSubmenus
            };
          }
          const filteredSubmenus = visibleSubmenus.filter(item => match(item.title));
          if (match(group.title)) {
            return {
              ...group,
              items: visibleSubmenus
            };
          }
          if (filteredSubmenus.length > 0) {
            return {
              ...group,
              items: filteredSubmenus
            };
          }
          return null;
        })
        .filter(Boolean);
    },

  },

  methods: {

    handleClick(action) {
      if (action !== "") {
        this[action]();
      }
    },

    logOut() {
      this.$store.dispatch("auth/logout");
      this.$router.push("/login");
    },

    lookupImageUrl(item) {
      // console.log(JSON.stringify(item))

      if (item.avatarImage === undefined || item.avatarImage === "") {
        return require("@/assets/images/account_icon.png");
      } else {
        return FileService.image_url_verylow(item.avatarImage);
      }
    },

    lookupImageUrlLazy() {
      return require("@/assets/images/account_icon.png");
    },
    toChangeProfile() {
      this.$router.push("/change-profile");
    },
    fetchParent() {
      const divisionId = Number(this.currentUser?.fdivisionBean || 0);
      if (!Number.isInteger(divisionId) || divisionId <= 0) {
        this.currentUserDivision = { id: 0, description: "" };
        return;
      }

      FDivisionService.getFDivisionById(divisionId).then(
          response => {
            // console.log(JSON.stringify(response.data));
            this.currentUserDivision = response.data;
          },
          error => {
            this.currentUserDivision = { id: divisionId, description: "" };
            if (error.response && error.response.status === 404) {
              console.warn(`FDivision user login tidak ditemukan: ${divisionId}. Silakan login ulang atau perbaiki fdivisionBean user.`);
              return;
            }
            console.error(error);
          }
      )
    },
  },
  mounted() {

    if (this.currentUser) {
      this.fetchParent()
    }

    TestService.getAdminBoard().then(
      () => {},
      (error) => {

        if (error.response.status === 401) {
          if (this.currentUser !== undefined || this.currentUser !== "") {
            this.$store.dispatch("auth/logout");
            this.$router.push("/login");
          }
        }
      }
    );
  },
};
</script>

<style scoped>
.nav-color{
  background-image: linear-gradient(to top left, #00386c 10%, transparent 90%);
}
.nav-color-second{
  background-color: #135B51FF;
}
.search-field :deep(.v-field__input) {
  color: #dddada !important;
  text-align: center;
  justify-content: center;
}
.search-field :deep(input) {
  color: #e8e7e7 !important;
  text-align: center;
}
.search-field :deep(input::placeholder) {
  color: rgba(255, 255, 255, 0.6) !important;
  text-align: center;
}
.search-field :deep(.v-label) {
  color: rgba(255, 255, 255, 0.7) !important;
}
</style>
